'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _iBem = require('../../common.blocks/i-bem/i-bem.react');

exports.default = (0, _iBem.decl)({
    block: 'textinput',
    didMount: function didMount() {
        if (this.props.autoFocus) {
            this.focus();
        }
    }
});